export default {
  title: '欢迎来到 gotin',
  defaultTitle: '有了gotin',
  experience: '等你体验',
  password: '密码',
  forgotPassword: '忘记密码',
  started: '登录',
  tips: '点击“登录”或“领英登录”即代表您已阅读并同意使用条款。',
  register: '注册账号',
  newUser: '新用户？',
  or: '或者',
  success: '登录成功',
  failed: '登录失败，请稍后重试',

  //
  welcomeTo: '欢迎来到',
  gsma2020: 'Gotin',
  inputEmailPop: '邮箱账户',
  forgetPass: '忘记密码',
  login: '登录',
  linkedinLogin: '领英登录',
  newUser1: '新用户',
  registerNew: '注册账号',
  registerRule: '点击“登录”或“领英登录”即代表您已阅读并同意使用条款。',
  inputEmail: '请输入邮箱',
  setPassPop: '请输入密码',
  emailValidationSuccess: '邮件验证通过',
  emailValidationFailure: '验证邮件失败，请重新登录获取新的账户激活链接',
  attention: '注意',
  confirm: '确定',
  notValidateEmailYet: '您还没有通过邮箱验证，请检查邮箱激活链接点击激活',
  wrongCredential: '密码或者邮箱不正确，请重试',
  pleaseLoginToViewContent: '请登录后再观看此内容',
  phoneRules: '请输入正确的手机号',
  needCanUseEmail: '必须是正确的邮箱',
  loginRules: '请输入正确的邮箱或手机号',
  signInwithVerificationCode: '验证码登录',
  phoneNumber: '手机号码',
  verificationCode: '验证码',
  enterEvent: '加入活动',
  phone: '手机',
  email: '邮箱',
  passwords: '密码',
  forgetPassword: '忘记密码',
  signInWithPassword: '密码登录',
  enterYourEmail: '请输入邮箱',
  signIn: '登录',
  SignUp: '没有账号？去注册',
  continue: '继续',
  wrongSecurityCode: '验证码错误',
  alreadyRegistered: '登录',
  alreadyRegisteredBefore: '已有账号？去登录',
  sendAgain: '再次发送',
  sendCode: '发送验证码',
  sendCodePorsche: '获取验证码',
  newSignup: '注册',
  welcome: '欢迎回来！',
  welcomeNjcb: '欢迎进入“你好世界”，\n开启元宇宙探索之旅！',
  welcomeZl: '出发！职场多元宇宙',
  welcomePorsche: '欢迎进入梦想俱乐部',
  welcomePorscheHR: '欢迎进入波子大都会',
  welcomeNissan: '欢迎来到尽兴e家',
  welcomeAiahrn: '欢迎来到\n友邦易空间',
  welcomePorsche911: '欢迎来到',
  welcomeSubPorsche911: '保时捷梦想城',
  titlePorsche911: '保时捷梦想城',
  addPersonalInfo: '请补充个人信息',
  tokenSent: '验证码发送成功',
  zlzpLogin: '进入',
  porscheLogin: '进入',
  welcomePorschetaycan: '欢迎进入',
  welcomeSubPorschetaycan: '保时捷睿云艺术馆',
  titlePorscheTaycan: '睿云艺术馆',
  welcomeNjcbmeets: '欢迎进入你好世界',
  welcomeTakedaspark: '欢迎进入武田路演活动',
  bindPhoneAgain: '系统检测到该手机号已注册过，是否使用已有手机号进行登录？',
  yes: '是',
  no: '否',
}
